import React from 'react';
import { FileText, Target, DollarSign, Clock, CheckCircle, Zap } from 'lucide-react';

const InquiryAnalysisPanel = ({ analysis, inquiry }) => {
  if (!analysis && !inquiry) return null;

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-4">
      <div className="flex items-center gap-3 mb-6">
        <FileText className="w-6 h-6 text-indigo-600" />
        <h2 className="text-2xl font-bold text-gray-900">Inquiry Analysis</h2>
      </div>
      {/* Position Required */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-2">
          <Target className="w-5 h-5 text-indigo-600" />
          <h3 className="font-semibold text-gray-900">Position Required</h3>
        </div>
        <p className="text-gray-700 bg-indigo-50 px-4 py-2 rounded-lg">
          {analysis?.positionRequired || inquiry?.positionRequired}
        </p>
      </div>
      {/* Budget Range */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-2">
          <DollarSign className="w-5 h-5 text-green-600" />
          <h3 className="font-semibold text-gray-900">Budget Range</h3>
        </div>
        <p className="text-gray-700 bg-green-50 px-4 py-2 rounded-lg">
          {analysis?.budgetRange || `${inquiry?.budgetMin?.toLocaleString()} - ${inquiry?.budgetMax?.toLocaleString()} ${inquiry?.currency}`}
        </p>
      </div>
      {/* Timeline */}
      {(analysis?.timeline || inquiry?.timelineDeadline) && (
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <Clock className="w-5 h-5 text-orange-600" />
            <h3 className="font-semibold text-gray-900">Timeline</h3>
          </div>
          <p className="text-gray-700 bg-orange-50 px-4 py-2 rounded-lg">
            {analysis?.timeline || new Date(inquiry?.timelineDeadline)?.toLocaleDateString()}
          </p>
        </div>
      )}
      {/* Key Requirements */}
      {analysis?.keyRequirements && analysis?.keyRequirements?.length > 0 && (
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-3">
            <CheckCircle className="w-5 h-5 text-blue-600" />
            <h3 className="font-semibold text-gray-900">Key Requirements</h3>
          </div>
          <ul className="space-y-2">
            {analysis?.keyRequirements?.map((req, index) => (
              <li key={index} className="flex items-start gap-2 text-gray-700">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 flex-shrink-0"></span>
                <span>{req}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {/* Tactical Preferences */}
      {analysis?.tacticalPreferences && analysis?.tacticalPreferences?.length > 0 && (
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-3">
            <Zap className="w-5 h-5 text-purple-600" />
            <h3 className="font-semibold text-gray-900">Tactical Preferences</h3>
          </div>
          <div className="flex flex-wrap gap-2">
            {analysis?.tacticalPreferences?.map((pref, index) => (
              <span
                key={index}
                className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-medium"
              >
                {pref}
              </span>
            ))}
          </div>
        </div>
      )}
      {/* Description */}
      {inquiry?.description && (
        <div>
          <h3 className="font-semibold text-gray-900 mb-2">Description</h3>
          <p className="text-gray-600 text-sm leading-relaxed bg-gray-50 px-4 py-3 rounded-lg">
            {inquiry?.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default InquiryAnalysisPanel;